import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=81fdc65e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81fdc65e')) {
      api.createRecord('81fdc65e', component.options)
    } else {
      api.reload('81fdc65e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=81fdc65e&", function () {
      api.rerender('81fdc65e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2bybKoOlWb5/JS/imageCarousel.vue"
export default component.exports